import {Component, OnInit, ViewChild, inject} from '@angular/core';
import {
    TableColumnFilterType,
    TableConfig,
    TableFieldAlignment, TableRowColorConditionOperator
} from '../../../global/components/table/table.interfaces';
import {UserService} from '../../../global/services/user.service';
import {DataService} from '../../../global/services/data.service';
import {TableComponent} from '../../../global/components/table/table.component';
import {ToastrService} from "ngx-toastr";
import {NgIf, NgFor} from '@angular/common';
import {RightPipe} from '../../../global/pipes/right.pipe';

@Component({
    selector: 'app-task-type-list',
    templateUrl: './task-type-list.component.html',
    styleUrl: './task-type-list.component.scss',
    imports: [TableComponent, NgIf, NgFor, RightPipe]
})
export class TaskTypeListComponent implements OnInit {

    userService = inject(UserService);
    private dataService = inject(DataService);
    private toastrService = inject(ToastrService);

    @ViewChild('tableComponent') tableComponent!: TableComponent;

    tableConfig!: TableConfig;
    count: any;
    standardSet!: any[] | null;

    ngOnInit(): void {
        this.getCount();

        this.tableConfig = {
            titleIcon: 'fas fa-tag',
            title: 'Aufgabentypen',
            openDatasetRouterLink: '/app/tasktype/detail',
            enableCreate: this.userService.hasRight('MASTER_DATA_EDIT'),
            enableExportExcel: true,
            description: 'Kategorisierung von Aufgaben in beliebige Typen.',
            dataConfig: {
                tableName: 'tasktype',
                tableIndexName: 'TTID',
                tableFields: [
                    {key: 'name', name: 'name', title: 'Name', sortable: true, searchable: true},
                    {
                        key: 'used',
                        subquery: '(SELECT COUNT(*) FROM task WHERE TTID = tasktype.TTID)',
                        sortable: true,
                        title: '# Zugewiesen',
                        alignment: TableFieldAlignment.RIGHT
                    }
                ],
                rowImage: [
                    {
                        key: 'used',
                        icon: 'fa-exclamation-triangle',
                        color: '#ffc107',
                        conditions: [
                            {key: 'used', value: '0', operator: TableRowColorConditionOperator.EQUAL},
                        ],
                        tooltip: 'Aufgabentyp wurde nirgends zugewiesen'
                    },
                ],
                reverse: false,
                order: 'name',
                columnFilter: {
                    enabled: false,
                    fields: {
                        name: {value: '', type: TableColumnFilterType.INPUT},
                    }
                }
            },
            localStorage: {
                version: 1,
                name: 'task-type-list',
                enabled: true
            },
            paginConfig: {
                id: 'taskTypeList',
                rowFields: ['5', '10', '15', '20', '25', '30', '35', '40', '45', '50'],
                itemsPerPageDb: true,
                itemsPerPage: 10,
                currentPage: 1,
            }
        };
    }

    getCount(): void {
        this.dataService.request('TaskType/count').subscribe(response => {
            this.count = response.count;
        });
    }

    loadSet(): void {
        this.dataService.request('TaskType/loadSet').subscribe(response => {
            this.standardSet = null;
            this.getCount();
            this.tableComponent.load();
            this.toastrService.success('Das Standardset wurde geladen');
        });
    }

    listStandardSet() {
        this.dataService.request('TaskType/listSet').subscribe(response => {
            this.standardSet = response.set;
        });
    }
}
